<template>
<div class="chapter">
<div class="inner_page">
<p class="noindenti"><a id="page_vii"></a></p>
<p class="copyright">Copyright © 2008 by Joe McGinniss Jr.</p>
<p class="copyright">All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, or the facilitation thereof, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.</p>
<p class="copyright">This novel is entirely a work of fiction. The names, characters and incidents portrayed in it are the work of the author’s imagination. Any resemblance to events, localities or actual persons, living or dead, is entirely coincidental.</p>
<p class="copyright"><em>Published simultaneously in Canada<br/>Printed in the United States of America</em></p>
<p class="copyright"><span class="small">FIRST EDITION</span></p>
<p class="copyright">eBook ISBN-13: 978-1-5558-4826-2</p>
<p class="copyright">Black Cat<br/>a paperback original imprint of Grove/Atlantic, Inc.<br/>841 Broadway<br/>New York, NY 10003</p>
<p class="copyright">Distributed by Publishers Group West</p>
<p class="copyright"><span class="weblink"><a href="http://www.groveatlantic.com" target="_blank">www.groveatlantic.com</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?73e7299c